/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DownloadInputs */

const en_download = /** @type {(inputs: DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const id_download = /** @type {(inputs: DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduh`)
};

/** @type {(inputs: DownloadInputs) => LocalizedString} */
const es_download = en_download;

/** @type {(inputs: DownloadInputs) => LocalizedString} */
const fr_download = en_download;

/** @type {(inputs: DownloadInputs) => LocalizedString} */
const de_download = en_download;

/** @type {(inputs: DownloadInputs) => LocalizedString} */
const ja_download = en_download;

/** @type {(inputs: DownloadInputs) => LocalizedString} */
const zh_download = en_download;

/** @type {(inputs: DownloadInputs) => LocalizedString} */
const ar_download = en_download;

/** @type {(inputs: DownloadInputs) => LocalizedString} */
const it_download = en_download;

/** @type {(inputs: DownloadInputs) => LocalizedString} */
const ru_download = en_download;

/** @type {(inputs: DownloadInputs) => LocalizedString} */
const pt_download = en_download;

/** @type {(inputs: DownloadInputs) => LocalizedString} */
const ko_download = en_download;

/**
* | output |
* | --- |
* | "Download" |
*
* @param {DownloadInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const download = /** @type {((inputs?: DownloadInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DownloadInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_download(inputs)
	if (locale === "es") return es_download(inputs)
	if (locale === "fr") return fr_download(inputs)
	if (locale === "de") return de_download(inputs)
	if (locale === "ja") return ja_download(inputs)
	if (locale === "zh") return zh_download(inputs)
	if (locale === "ar") return ar_download(inputs)
	if (locale === "id") return id_download(inputs)
	if (locale === "it") return it_download(inputs)
	if (locale === "ru") return ru_download(inputs)
	if (locale === "pt") return pt_download(inputs)
	return ko_download(inputs)
});